<div class="list">

  <div>
    
  </div>
  <div *ngIf="product_detail1 && product_detail1.is_template != 1" class="side-three active" [ngClass]="db.ismobile ? 'slide-top':''">
    <div class="segment" >
      <div [class.active]="db.botton_name == 'edit'" (click)="btn_change('edit')" class="mouse btn ion-activatable ripple-parent">Edit Product</div>
      <div [class.active]="db.botton_name == 'price'" (click)="btn_change('price')" class="mouse btn ion-activatable ripple-parent">Manage Price </div>
    </div>
  </div>
  
  <div *ngIf="product_detail1 && product_detail1.is_template == 1" class="side-three active" [ngClass]="db.ismobile ? 'slide-top':''">
    <div class="segment" >
      <div class="bold_name mouse btn ion-activatable ripple-parent">Manage Price </div>
    </div>
  </div>
  
  
  
  <div class="view_product" *ngIf="db.botton_name == 'edit' && product_detail"><app-view-product [product_id]="product_detail" [header_none]="true" title="Edit" [input_box_width]="'100%'" [is_not_shown]="true"></app-view-product></div>
  
  <div *ngIf="db.botton_name == 'price' && db.is_show && product_detail1;else no_detail" class="deatail_container">
    <ion-item lines="none" class="product_title no-ripple">
      <ion-thumbnail slot="start">
        <img src="{{db.product_img(product_detail1.product_image)}}" defaultImage="" alt="">
      </ion-thumbnail>
      <ion-label>
          <h3>{{product_detail1.product_name | titlecase}}</h3>
          <h5 style="color:#757575;">{{product_detail1.centre | titlecase}}</h5>
      </ion-label>
      <!-- <div (click)="closeDetail()" class="close_icon mouse">
        <ion-icon name="close-outline"></ion-icon>
      </div> -->
    </ion-item>
    <div class="box__" *ngIf="product_detail1.variants  && product_detail1.variants.length != 0">
      <div *ngFor="let variant of product_detail1.variants,let index=index;" class=" varaint_div">
        <div [innerHTML]="variant.combination_text" class="inner_html small_name"></div>
        <div class="d__flex gap-10 align-c mt10">
          <div class="price_div">
            <!-- <ion-label class="m-0 input_label custom_label">Old Price</ion-label> -->
            <ion-label class="m-0 input_label custom_label">MRP</ion-label>
             <ion-input #price type="number" [disabled]="(variant.stock == 0 || variant.product_status == 'Inactive')" min="0" [(ngModel)]="variant.old_price" name="old_price" (ionFocus)="select_value($event)" (ionBlur)="getPrice($event,variant,'old')"></ion-input>
          </div>
          <div class="price_div">
            <ion-label class="m-0 input_label custom_label">Price</ion-label>
            <ion-input type="number" min="0" [disabled]="(variant.stock == 0 || variant.product_status == 'Inactive')" [(ngModel)]="variant.price" name="price" (ionFocus)="select_value($event)" (ionBlur)="getPrice($event,variant,'new')"></ion-input>
          </div>
          <div class="price_div">
            <ion-label class="m-0 input_label custom_label">Stock</ion-label>
            <ion-input type="number" [disabled]="true" [(ngModel)]="variant.stock ? variant.stock : null_stock_value" name="actual_price"></ion-input>
          </div>
        </div>
        <h4 *ngIf="variant.modified" class="updated_on small_name m-0">  <span class="line_2">Updated On :  </span> {{variant.modified | date : 'MMM d, y, h:mm a'}}</h4>  
      </div>
    </div>
    <div *ngIf="product_detail1.variants.length == 0" class="varient_less  box__">
      <div class="varaint_div  d__flex gap-10 align-c mt10">
        <div class="price_div">
          <!-- <ion-label class="m-0 input_label custom_label">Old Price</ion-label> -->
          <ion-label class="m-0 input_label custom_label">MRP</ion-label>
           <ion-input  #price type="number" min="0" [disabled]="(product_detail1.stock == 0 || product_detail1.product_status == 'Inactive')" [(ngModel)]="product_detail1.old_price" name="mrp_price" (ionFocus)="select_value($event)" (ionBlur)="getPrice($event,product_detail1,'old')"></ion-input>
        </div>
        <div class="price_div">
          <ion-label class="m-0 input_label custom_label">Price</ion-label>
          <ion-input type="number" min="0" [disabled]="(product_detail1.stock == 0 || product_detail1.product_status == 'Inactive')" [(ngModel)]="product_detail1.price" name="actual_price" (ionFocus)="select_value($event)" (ionBlur)="getPrice($event,product_detail1,'new')"></ion-input>
        </div>
        <div class="price_div">
          <ion-label class="m-0 input_label custom_label">Stock</ion-label>
          <ion-input type="number" [disabled]="true" [(ngModel)]="product_detail1.stock ? product_detail1.stock : null_stock_value" name="actual_price"></ion-input>
        </div>
      </div>
      <h4 *ngIf="product_detail1.modified" class="updated_on small_name m-0">  <span class="line_2">Updated On :  </span> {{product_detail1.modified | date : 'MMM d, y, h:mm a'}}</h4>  
  
    </div>
  </div>
  
  <div *ngIf="db.botton_name == 'price' && db.is_show && product_detail1.product_status != 'Inactive' && product_detail1;" class="animated fadeInUp add_price_button">
    <!-- <ion-button (click)="db.ismobile ? save(product_detail1) : submit.emit({'message':product_detail1,'index':selected_index})" class="add_i_btn" fill="clear">Update Price</ion-button> -->
    <ion-button (click)="save(product_detail1)" class="add_i_btn" fill="clear">Update Price</ion-button>
  </div>
  
  <ng-template #no_detail>
    <app-no-record-found *ngIf="db.is_show && !product_detail1" [column]="true" height="calc(100vh - 263px)" heading="Please Select Product" [image]="'assets/no-product-POS.svg'"></app-no-record-found>
  </ng-template>
  
  
  <ion-list *ngIf="!db.is_show" class="varaint_div d__flex gap-10 align-c" style="padding: 0;">
      <div class="deatail_container" style="width: 100%;">
        <ion-item lines="none" class="product_title no-ripple">
          <ion-thumbnail slot="start">
            <ion-skeleton-text [animated]="true" style="border-radius: 0;"></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
              <h3> <ion-skeleton-text [animated]="true" style="width: 80%;"></ion-skeleton-text></h3>
              <h5 style="color:#757575;"> <ion-skeleton-text [animated]="true" style="width: 80%;"></ion-skeleton-text></h5>
          </ion-label>
        </ion-item>
        <div class="box__">
          <div *ngFor="let item of [1,2]"  class="varaint_div">
            <div  class="inner_html">
              <ion-skeleton-text [animated]="true" style="width: 30%;"></ion-skeleton-text>
            </div>
            <div class="d__flex gap-10 align-c mt10">
              <div class="" style="width: 50%;height: 35px;">
             <ion-skeleton-text [animated]="true" style="border-radius: 0;"></ion-skeleton-text>
              </div>
              <div class="" style="width: 50%;height: 35px;">
                 <ion-skeleton-text [animated]="true" style="border-radius: 0;"></ion-skeleton-text>
              </div>
            </div>
          </div>
        </div>
      </div>
  
  </ion-list>

</div>

